import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { taskGoalDepartment } from '@battleops/shared';
import { useTasks } from '@battleops/client/src/context/TaskContext';
import { useProjects } from '@battleops/client/src/context/ProjectContext';
import { useDepartments } from '@battleops/client/src/context/DepartmentContext';

/**
 * "Make this a goal" (boards B7): the builder on the task's own department's score page, opened on the task —
 * /department/<id>?add=1&goalTask=<taskId> (Department.jsx opens GoalBuilder pre-filled). → (task) => void
 */
export function useMakeTaskGoal() {
  const navigate = useNavigate();
  const { tasks } = useTasks();
  const { projects } = useProjects();
  const { rawDepartments, departmentMode } = useDepartments();
  return useCallback((task) => {
    const d = taskGoalDepartment(task, { tasks, projects, departments: rawDepartments || [], departmentMode });
    if (d) navigate(`/department/${d.id}?add=1&goalTask=${encodeURIComponent(task.id)}`);
  }, [navigate, tasks, projects, rawDepartments, departmentMode]);
}
